/**
 * Shopping Api
 * The Shopping api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormCardModel } from './formCardModel';


export interface FormModel { 
    method: FormModel.MethodEnum;
    endpoint: string;
    title: string;
    subtitle: string;
    cancelLabel: string;
    submitLabel: string;
    fields: Array<string>;
    cards: Array<FormCardModel>;
}
export namespace FormModel {
    export type MethodEnum = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
    export const MethodEnum = {
        GET: 'GET' as MethodEnum,
        POST: 'POST' as MethodEnum,
        PUT: 'PUT' as MethodEnum,
        PATCH: 'PATCH' as MethodEnum,
        DELETE: 'DELETE' as MethodEnum
    };
}


